'use strict';

frontendApp.filter('pad', [function () {

  return function (number, size, character) {
    if (number) {
      var pad_char = typeof character !== 'undefined' ? character : '0';

      size -= number.toString().length;
      if (size > 0) {
        return new Array(size + (/\./.test(number) ? 2 : 1)).join(pad_char) + number;
      }
      return number + ""; // always return a string
    }
  }
}]);
